import React from 'react'

import { CrFormHandle, CrFormStep } from '@/components/Event/CrForm/CrFormStep'
import { Step } from '@/components/Event/CrForm/Step'
import { useRegisterStepFields } from '@/components/Event/CrForm/useStepField'
import { CRPresenceAlert } from '@/components/Event/Feedback/CRPresenceAlert'
import { PreparationInfoAlert } from '@/components/Event/Feedback/PreparationInfoAlert'
import { Event } from '@/types'

const CR_JOINED_PATH = ['sa.cr_joined']
const RegisterStepFields: React.FC<{ paths: string[] }> = ({ paths }) => {
  useRegisterStepFields(paths)
  return null
}

// Base scaffold: wraps the existing Preparation content.
export const PreparationStep: React.FC<{
  event: Event
  form: CrFormHandle
}> = ({ event, form }) => (
  <Step
    id={CrFormStep.PREPARATION}
    title="Preparation"
    form={form}
    nextStepId={CrFormStep.ATTENDANCE}
  >
    <RegisterStepFields paths={CR_JOINED_PATH} />
    <CRPresenceAlert eventId={event.id} form={form} />
    <PreparationInfoAlert event={event} />
  </Step>
)
